export default "__VITE_ASSET__DwMzgwki__"